// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the MIT License.

import { registerServiceBusMessageFactory } from './servicebus/registerServiceBusMessageFactory';

registerServiceBusMessageFactory();
